import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, toRefs, computed } from "vue";
import { DecoratedAsset } from "@/types";
import { assetUpdateMatchesProperties } from "@/utils/state-management";

interface Props {
  asset: DecoratedAsset;
  properties?: string[] | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetUpdateProgress',
  props: {
    asset: null,
    properties: { default: null }
  },
  setup(__props: any) {

const props = __props as { asset: DecoratedAsset, properties: string[] | null }



const { asset, properties } = toRefs(props);

const visible = computed(() => {
  const { updateStatus } = asset.value;
  if (!updateStatus) return false;

  if (properties.value) return assetUpdateMatchesProperties(asset.value, properties.value);
  else {
    const values = Object.values(updateStatus.properties);
    const completeCount = values.filter(v => v).length;
    return completeCount < values.length;
  }
});

const completionPct = computed(() => {
  const { updateStatus } = asset.value;
  if (!updateStatus) return 0;

  const values = Object.values(updateStatus.properties);
  const completeCount = values.filter(v => v).length;
  return (completeCount / values.length) * 100;
});

return { __sfc: true,props, asset, properties, visible, completionPct }
}

})